<template>
  <div style="background: white !important;height: 100%;">
    <div class="hyy" v-if="welcomeMessage">欢迎语：{{welcomeMessage}}</div>
    <div v-if="flag">
      <div style="background: white">
        <div style="height: 50px;line-height: 50px;text-align: left;"  class="clearfix">
          <el-col :span="18">
            <span style="margin-left: 10px;color: #727D93;">访客登记列表 </span>
          </el-col>
          <el-col :span="6">
            <span @click="addPeer" style="margin-left: 10px;color: #2C68FF;font-weight: bold;cursor: pointer;">添加同行人 </span>
          </el-col>
        </div>
      </div>

      <div class="myform clearfix">
        <div class="line"></div>

        <div class="row clearfix">
          <el-col :span="23">
            <span style="margin-left: 10px;color: #727D93;">访客信息 </span>
          </el-col>
        </div>

        <div class="line"></div>

        <div class="row clearfix">
          <el-col :span="23">
            <van-field :maxlength="10" required v-model="formData['name']" label="姓名" placeholder="请输入您的姓名" />
          </el-col>
        </div>

        <div class="line"></div>

        <div class="row clearfix">
          <el-col :span="23">
            <van-field
                :maxlength="11"
                oninput ="value=value.replace(/[^\d]/g, '')"
                required
                v-model="formData['phoneNo']"
                label="电话"
                placeholder="请输入您的联系方式" />
          </el-col>
        </div>

        <div class="line"></div>

        <div class="row clearfix">
          <el-col :span="23">
            <van-field  readonly
                        clickable
                        is-link
                        required
                        name="datetimePicker"
                        :value="formData['areaName']"
                        label="居住地"
                        input-align="left"
                        placeholder="请选择居住地"
                        @click="onAddress" />
            <van-popup v-model="showAddress"
                       position="bottom"
                       :style="{ height: '50%' }" >
              <van-area title="请选择居住地"
                        @confirm="changeAddress"
                        :area-list="areaList"
                        columns-num="3" />
            </van-popup>

          </el-col>
        </div>

        <div class="line"></div>

        <div class="row clearfix">
          <el-col :span="23">
            <van-field  :maxlength="20" v-model="formData['unit']" label="单位" placeholder="请输入您的单位" />
          </el-col>
        </div>

        <div class="line"></div>


<!--      <div style="width: 100%;height: 260px;overflow-y: auto;background: white;">-->
        <div v-if="formData.peers.length" style="width: 100%;height: 10px;box-shadow: 0 10px 10px 0 #eaeef4; "></div>
        <div v-for="(item, index) in formData.peers" class="pear clearfix">

          <div style="height: 20px;line-height: 40px;"  class="row clearfix">
            <span style="margin-left: 10px;"> 同行访客（{{index+1}}/20） </span>
          </div>

          <div class="line"></div>

          <div @click="delPeer(index)" class="delbtn clearfix">
            删除
          </div>
          <div class="row clearfix">
            <el-col :span="23">
              <van-field :maxlength="10" required v-model="item['name']" label="姓名" placeholder="请输入您的姓名" />
            </el-col>
          </div>

          <div class="line"></div>

          <div class="row clearfix">
            <el-col :span="23">
              <van-field
                  :maxlength="11"
                  oninput ="value=value.replace(/[^\d]/g, '')"
                  required
                  v-model="item['phoneNo']"
                  label="电话"
                  placeholder="请输入您的联系方式" />
            </el-col>
          </div>
          <div class="line"></div>
        </div>
      </div>
      <div class="footer" @click="submit">提交登记</div>
    </div>

    <div style="padding-top: 200px;" v-else>
      <img style="width: 200px;" :src="dlcg" alt="">
      <div style="font-size: 21px;font-weight: bold;">登记成功</div>
      <div class="ok" @click="okClick">好的</div>
    </div>
  </div>
</template>

<script>
import {
  saveVisitor
} from '@/api/admin'
import { areaList } from '@vant/area-data';

export default {
  components: {

  },
  data() {
    return {
      showAddress:false,
      searchResult: [],
      areaList,
      flag: true,
      dlcg: require('../../../static/imgV2/dlcg.png'),
      welcomeMessage: this.$route.query.welcomeMessage,
      formData: {
        robotId: this.$route.query.robotId ,
        name: "",
        phoneNo: "",
        unit: "",
        areaName :"",
        peers:[],
        peersData: "",
        visitorNum: null,
      }
    }
  },
  props: [],
  mounted() {
    document.title = '访客登记'
  },
  methods: {
    onAddress(){
      this.showAddress=true
    },
    // 点击地址选择框的确认
    changeAddress(event){
      // console.log(event,'返回格式数组')
      this.showAddress=false
      this.formData.areaName =   event.map((option) => option.name).join('/');

    },
    submit(){
      if(!this.formData.name.trim()){
        this.$message.error('姓名不能为空');
        return
      }
      if(!this.formData.phoneNo){
        this.$message.error('电话不能为空');
        return
      }
      if(this.formData.phoneNo.length != 11){
        this.$message.error('电话号必须为11位！');
        return
      }
      if(!this.formData.areaName){
        this.$message.error('居住地不能为空');
        return
      }
      if(this.formData.peers.length){
        for(let i = 0;i < this.formData.peers.length; i++){
          let res = this.formData.peers[i];

          if(!res.name.trim() ||  !res.phoneNo){
            this.$message.error('同行人'+(i+1)+":信息填写不完整！");
            return
          }
          if(res.phoneNo.length != 11){
            this.$message.error('同行人'+(i+1)+":电话号必须为11位！");
            return
          }
        }
      }
      this.formData.peersData = this.formData.peers.length ? JSON.stringify(this.formData.peers) : "";
      this.formData.visitorNum = this.formData.peers.length + 1;
      console.log(this.formData);
      saveVisitor(this.formData).then(res=>{
        this.flag = false;
      })
      // this.flag = false;

    },
    okClick(){
      this.formData = {
        robotId: this.$route.query.robotId ,
        name: "",
        phoneNo: "",
        unit: "",
        areaName :"",
        area:[],
        peers:[],
        peersData: "",
        visitorNum: null,
      }
      this.flag = true;
    },
    delPeer(index){
      console.log(index)
      this.formData.peers.splice(index,1)
    },
    addPeer(){
      if(this.formData.peers.length < 20){
        this.formData.peers.push({
          name: "",
          phoneNo: "",
        })
      }
    },
    areaChange(){
      this.formData.areaName =  this.formData.area && this.formData.area.join("/")
      console.log(this.formData.areaName )
    }
  }
}

</script>

<style scoped lang="less">

.title{
  font-size: 20px;
  line-height: 50px;
}
.hyy{
  text-align: left;
  margin: 10px 5px;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.myform{
  overflow: auto;
  height: 600px;
  padding: 10px 5px;
}
.el-cascader {
  display: inline-block;
  position: relative;
  width: 100%;
  font-size: 14px;
  line-height: 30px;
}
/deep/.el-input__inner{
  height: 32px !important;
  line-height: 32px !important;
}
/deep/.van-cell {
  padding: 0 16px !important;
  font-size: 16px;
}
/deep/.van-cell::after {
  border-bottom: none;
}
.pear{
  box-shadow: 0 10px 10px 0 #eaeef4;
  position: relative;
  /*border: 1px gray dotted;*/
  margin-bottom: 10px;
}
.row{
  height: 20px;
  line-height: 20px;
  text-align: left;
  margin: 20px 0px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: -4px;
  color: #E9EFFF;
  background: #2C68FF;
  width: 100%;
  margin: 5px auto;
  height: 50px;
  line-height: 50px;
}
.line{
  width: 100%;
  border-bottom: 1px gainsboro solid;
}
.delbtn{
  cursor: pointer;
  font-weight: bold;
  color: #F66767;
  position: absolute;
  top: 10px;
  right: 20px;
}
.ok{
  border-radius: 5px;
  font-weight: bold;
  font-size: 22px;
  color: white;
  width: 50%;
  background: #2C68FF;
  height: 40px;
  line-height: 40px;
  margin: 40px auto;
}
</style>



// WEBPACK FOOTER //
// src/page/visitor/index.vue